import {
    loginService,
    tokenValidate,
    forgotPasswordService,
    resetPasswordService,
    profileUpdateService,
    changePasswordService,
    getMyModuleAccessService,
} from "../services/auth";

export const auth = {
    state: {
        userInfo: {},
        moduleAccess: null,
        isbootstrapped: false
    },
    reducers: {
        setUserInfo: (state, data) => {
            return {
                ...state,
                userInfo: data,
                userInfoData: data.userInfo,
            };
        },
        setModuleAccess: (state, moduleAccess) => {
            return {
                ...state,
                moduleAccess,
            };
        },
        setBootstrapped: (state, isbootstrapped) => {
            return {
                ...state,
                isbootstrapped,
            };
        },
        resetSession: (state) => {
            return {
                ...state,
                userInfo: {},
                userInfoData: undefined,
                moduleAccess: null,
                isbootstrapped: true,
            };
        },
    },
    effects: (dispatch) => ({
        async loadModuleAccess() {
            try {
                const responseData = await getMyModuleAccessService();
                return responseData?.data || {};
            } catch (err) {
                console.log("err", err);
                return {};
            }
        },
        async loginUser(userdata) {
            try {
                const responseData = await loginService(userdata);
                const sessionData = responseData?.data || {};

                if (!sessionData || !sessionData.token || responseData?.status === false) {
                    const errMsg =
                        responseData?.data?.message ||
                        responseData?.data?.error ||
                        responseData?.message ||
                        "Invalid email or password";
                    throw new Error(errMsg);
                }

                localStorage.setItem("logininfo", JSON.stringify(sessionData));

                let moduleAccess = null;
                try {
                    moduleAccess = await dispatch.auth.loadModuleAccess();
                } catch (accessErr) {
                    console.log("Module access load warning:", accessErr);
                }

                const updatedSession = {
                    ...sessionData,
                    moduleAccess,
                };

                localStorage.setItem("logininfo", JSON.stringify(updatedSession));
                this.setUserInfo(updatedSession);
                this.setModuleAccess(moduleAccess);
                this.setBootstrapped(true);
                return updatedSession;
            } catch (err) {
                console.log("err", err);
                throw err;
            }
        },
        async forgotPassword(userdata) {
            try {
                const ResponseData = await forgotPasswordService(userdata);
                return ResponseData?.data;
            } catch (err) {
                console.log("err", err);
                throw err
            }
        },
        async resetPassword(userdata) {
            try {
                const ResponseData = await resetPasswordService(userdata);
                return ResponseData;
            } catch (err) {
                console.log("err", err);
                throw err
            }
        },
        async logOut(userdata) {
            try {
                localStorage.removeItem("logininfo");
                this.resetSession();
            } catch (err) {
                console.log("err", err);
                throw err;

            }
        },
        async validateToken() {
            try {
                const userInfoFromStorage = localStorage.getItem("logininfo");
                if (userInfoFromStorage) {
                    const userInfoData = JSON.parse(userInfoFromStorage);
                    if (userInfoData && userInfoData.token) {
                        const responseData = await tokenValidate({ token: userInfoData.token });
                        if (!responseData.data.istokenvalid) {
                            localStorage.removeItem("logininfo");
                            this.resetSession();
                        } else {
                            let moduleAccess = null;
                            try {
                                moduleAccess = await dispatch.auth.loadModuleAccess();
                            } catch (accessErr) {
                                console.log("Module access load warning on token validation:", accessErr);
                                moduleAccess = userInfoData.moduleAccess;
                            }

                            const updatedSession = {
                                ...userInfoData,
                                moduleAccess: moduleAccess || userInfoData.moduleAccess,
                            };
                            localStorage.setItem("logininfo", JSON.stringify(updatedSession));
                            this.setUserInfo(updatedSession);
                            this.setModuleAccess(updatedSession.moduleAccess);
                            this.setBootstrapped(true);
                        }
                    } else {
                        this.resetSession();
                    }
                } else {
                    this.resetSession();
                }
            } catch (err) {
                console.log("err", err);
                localStorage.removeItem("logininfo");
                this.resetSession();
            }
        },

        async profileUpdate(userdata) {
            try {
                const Responsedata = await profileUpdateService(userdata);
                const userInfoFromStorage = localStorage.getItem("logininfo");
                if (userInfoFromStorage && Responsedata && Responsedata.data && Responsedata.data.success) {
                    const userInfoData = JSON.parse(userInfoFromStorage);
                    const updatedData = {
                        token: userInfoData.token,
                        userInfo: Responsedata.data.updateddata,
                        moduleAccess: userInfoData.moduleAccess || null,
                    };
                    localStorage.setItem("logininfo", JSON.stringify(updatedData));
                    this.setUserInfo(updatedData);
                    this.setModuleAccess(updatedData.moduleAccess);
                }
                return Responsedata?.data;
            } catch (err) {
                console.log("err", err);
                throw err;

            }
        },

        async changePassword(userdata) {
            try {
                const Responsedata = await changePasswordService(userdata);
                return Responsedata?.data;
            } catch (err) {
                console.log("err", err);
                throw err;

            }
        },

    }),
}
